<div *ngIf="shouldShowChooseSchoolForm === false" class="container-fluid login-wrapper">
  <div class="row login-wrapper">
    <div class="col-md-6 d-flex justify-content-center login-bg">
      <form [formGroup]="form" class="login-form">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h1 class="page-title mb-0">{{ 'LOGIN' | translate }}</h1>
          <img class="d-md-none" src="assets/images/flex-logo-color.svg" width="126" alt="FlexTime Manager Logo" />
        </div>
        <p *ngIf="!directLoginProvider" class="mb-4">{{ 'PLATFORMS_DESCRIPTION' | translate }}</p>
        <p *ngIf="directLoginProvider" class="mb-4">
          {{ 'DIRECT_LOGIN_DESCRIPTION' | translate: { provider: directLoginProvider.title } }}
        </p>

        <div class="mb-5">
          <div *ngIf="!directLoginProvider" class="social-logins">
            <ng-container *ngFor="let provider of providers">
              <a class="social-link" (click)="onClickProvider(provider)">
                <span class="social-logo">
                  <img src="{{ provider.logo }}" title="{{ provider.logoTitle }}" />
                </span>
                <span class="social-title">{{ provider.title }}</span>
              </a>
            </ng-container>
          </div>
          <div *ngIf="directLoginProvider" class="social-logins">
            <a class="social-link" (click)="onClickProvider(directLoginProvider)">
              <span class="social-logo">
                <img src="{{ directLoginProvider.logo }}" title="{{ directLoginProvider.logoTitle }}" />
              </span>
              <span class="social-title">{{ directLoginProvider.title }}</span>
            </a>
          </div>
        </div>

        <div *ngIf="!directLoginProvider">
          <p>{{ 'LOGIN_DESCRIPTION' | translate }}</p>
          <div class="email-not-verify-alert" *ngIf="isUserNotVerified">
            <span>{{'EMAIL_NOT_VERIFIED_PLEASE_CHECK_EMAIL_OR' | translate}} <a  routerLink="/{{ appRoute.VerifyEmailAddress }}">{{ 'CLICK_HERE' | translate}}</a> {{'TO_ENTER_CODE' | translate}}</span><br>
          </div>
          <div class="form-group" appParentValidator [control]="form.controls.email">
            <div class="app-input">
              <label for="email">{{ 'EMAIL' | translate }}</label>
              <input
                autocomplete="email"
                type="text"
                class="form-control"
                placeholder="{{ 'YOUR_EMAIL' | translate }}"
                id="email"
                formControlName="email"
              />
            </div>
            <app-form-error [control]="form.controls.email"></app-form-error>
          </div>

          <div class="form-group" appParentValidator [control]="form.controls.password">
            <div class="app-input">
              <label for="password">{{ 'PASSWORD' | translate }}</label>
              <input
                autocomplete="current-password"
                type="password"
                class="form-control"
                placeholder="{{ 'YOUR_PASSWORD' | translate }}"
                id="password"
                formControlName="password"
              />
            </div>
            <app-form-error [control]="form.controls.password"></app-form-error>
          </div>

          <p class="mb-5">
            {{ 'FORGOTTEN_PASSWORD_MESSAGE' | translate }}
            <a class="social-link" [routerLink]="['/reset-password-initiate']">{{ 'FORGOTTEN_PASSWORD_LINK_MESSAGE' | translate }}</a>
          </p>
          
          <button type="submit" (click)="onLogin()" class="btn btn-primary btn-login">
            {{ 'LOGIN' | translate }}
          </button>
        </div>
        <div *ngIf="directLoginProvider">
          <p>
            {{ 'ALTERNATIVE_LOGIN' | translate: { provider: directLoginProvider.title } }}
          </p>
          <button routerLink="/{{ appRoute.Login }}" class="btn btn-text px-0">
            {{ 'GO_TO_LOGIN' | translate }}
          </button>
        </div>
      </form>
    </div>
    <div class="col-md-6 login-hero">
      <img class="logo d-none d-md-block" src="assets/images/securly-flex-white.svg" alt="FlexTime Manager Logo"     />
      <div class="links"><a href="https://eduspiresolutions.org/terms-of-use">Terms of Use</a> | <a href="https://eduspiresolutions.org/privacy-policy">Privacy Policy</a></div>
    </div>
  </div>

</div>

<form
  class="d-none"
  ngNoForm
  #logInForm
  action="{{ environment.EduSpireApi.domainSSOUrl }}/sso/login"
  enctype="multipart/form-data"
  method="POST"
>
  <input autocomplete="off" type="text" name="username" value="{{ form.controls.email.value }}" />
  <input autocomplete="off" type="password" name="password" value="{{ form.controls.password.value }}" />
  <ng-container *ngIf="inHouseProvider">
    <input type="text" name="client_id" value="{{ inHouseProvider.client_id }}" />
    <input type="text" name="redirect_uri" value="{{ inHouseProvider.redirect_uri }}" />
    <input type="text" name="response_type" value="{{ inHouseProvider.response_type }}" />
    <input type="text" name="scope" value="{{ inHouseProvider.scope }}" />
    <input type="text" name="code_challenge" value="{{ inHouseProvider.code_challenge }}" />
    <input type="text" name="code_challenge_method" value="{{ inHouseProvider.code_challenge_method }}" />
    <input type="text" name="state" value="{{ inHouseProvider.state }}" />
  </ng-container>
</form>

<div *ngIf="shouldShowChooseSchoolForm" class="container login-wrapper">
  <div class="row justify-content-center login-wrapper py-5">
    <div class="col-10 col-md-7 col-lg-5 align-self-center">
      <ng-container *ngIf="schools && schools.length > 0">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h1 class="page-title mb-0">{{ 'CHOOSE_SCHOOL' | translate }}</h1>
          <img src="assets/images/flex-logo-color.svg" width="126" alt="FlexTime Manager Logo" />
        </div>

        <p class="mb-5">{{ 'CHOOSE_SCHOOL_DESCRIPTION' | translate }}</p>
        <ul class="select-school">
          <ng-container>
            <li *ngFor="let school of schools" class="select-school-item">
              <div class="select-school-link" (click)="onChooseSchool(school)">
                <div class="school-logo">
                  <img [src]="school?.logo || 'assets/images/school-logo-default.svg' | safeUrl" />
                </div>
                <div class="school-name">{{ school.name }}</div>
              </div>
            </li>
          </ng-container>
        </ul>
      </ng-container>

      <p *ngIf="schools && schools.length === 0" class="mb-5 text-center">
        {{ 'THERE_IS_NO_ASSIGNED_SCHOOL_FOR_YOUR_ACCOUNT' | translate }}<br>
        <span class="btn btn-info btn-xs logout mt-3" (click)="onLogOut()">{{ 'LOGOUT' | translate }}</span>
      </p>
    </div>
  </div>
</div>
